import gql from 'graphql-tag'

import { responsiveImageFragment } from '../fragments/images.js'
// import { projectListingFragment } from '../fragments/projects.js'
import { seoFragment } from '../fragments/seo.js'

export const getHome = gql`
  ${responsiveImageFragment}
  ${seoFragment}
  query getHome($locale: SiteLocale) {
    allExpertises(locale: $locale, filter: {showInNavigation: {eq: "true"}}) {
      id
      title(locale: $locale)
      slug
      caption(locale: $locale)
      linkPreviewVideoListing
      imagePreviewListing {
        responsiveImage(
          imgixParams: { ar: "16:9", fit: crop, fm: webp, w: "1000" }
        ) {
          ...ResponsiveImageFragment
        }
      }
    }
    clinicalAreaPage(locale: $locale) {
        id
        aree(locale: $locale) {
          title
          name
          id
          image {
            id
            responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
              ...ResponsiveImageFragment
            }
          }
        }
      }  
      clinicalAreasListBlock(locale: $locale) {
      id
      block(locale: $locale) {
        title
        text
      }
    } 
    industriesListBlock(locale: $locale) {
      id
      block(locale: $locale) {
        title
        text
      }
    }  
    allIndustries(locale: $locale) {
    title(locale: $locale)
    slug
    imagePreviewListing {
        url
        responsiveImage(
          imgixParams: { auto: format, q: "40", ar: "16:9", fit: crop }
        ) {
          ...ResponsiveImageFragment
        }
      }
    imagePreviewCarousel {
      url
        responsiveImage(
          imgixParams: { auto: format, q: "40", ar: "4:5", fit: crop }
        ) {
          ...ResponsiveImageFragment
        }
     }      
    }
    clientiSection(locale: $locale) {
      title(locale: $locale)
      id
      imagesList {
        url
        alt
      }
    }  
    home(locale: $locale) {
      seo {
        ...SeoFragment
      }
      hero {
        id
        whiteText
        title
        text
        alignment
        previewVideo
        overlayFullVideo
        image {
          id
          responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
            ...ResponsiveImageFragment
          }
        }
          link {
                  id
                  linkLabel
                  linkUrl
                  internalLink {
                    ... on ContentRecord {
                      id
                      slug
                    }
                    ... on ContentsListingRecord {
                      id
                      name
                    }
                    ... on ExpertiseListingRecord {
                      id
                      name
                    }
                    ... on ExpertiseRecord {
                      id
                      slug
                    }
                    ... on IndustryListingRecord {
                      id
                      name
                    }
                    ... on IndustryRecord {
                      id
                      slug
                    }
                    ... on SolutionRecord {
                      id
                      slug
                    }
                    ... on SolutionsListingRecord {
                      id
                      name
                    }
                    ... on StudioPageRecord {
                      id
                      title
                    }
                    ... on AreYouAnAgencyRecord {
                      id
                    }
                    ... on ContactPageRecord {
                      id
                    }  
                  }
                }  
      }
      
      ctaType
      ctaDefaultPosition
      contactBannerBlock {
        id
        title
        subtitle
        videoUrl
        ctaLink
        ctaLabel
      }
        body(locale: $locale) {
            ... on TextBlockRecord {
            id
            text
            title
          }
      ... on ExpertiseGridRecord {
        id
        title
        subtitle
        expertise {
        id
      title
      slug
      caption
      linkPreviewVideoListing
      imagePreviewListing {
        responsiveImage(
          imgixParams: { ar: "16:9", fit: crop, fm: webp, w: "1000" }
        ) {
          ...ResponsiveImageFragment
        }
      }}
        link {
                  id
                  linkLabel
                  linkUrl
                  internalLink {
                    ... on ContentRecord {
                      id
                      slug
                    }
                    ... on ContentsListingRecord {
                      id
                      name
                    }
                    ... on ExpertiseListingRecord {
                      id
                      name
                    }
                    ... on ExpertiseRecord {
                      id
                      slug
                    }
                    ... on IndustryListingRecord {
                      id
                      name
                    }
                    ... on IndustryRecord {
                      id
                      slug
                    }
                    ... on SolutionRecord {
                      id
                      slug
                    }
                    ... on SolutionsListingRecord {
                      id
                      name
                    }
                    ... on StudioPageRecord {
                      id
                      title
                    }
                    ... on AreYouAnAgencyRecord {
                      id
                    }
                    ... on ContactPageRecord {
                      id
                    }  
                  }
                }  
      }
      ... on IndustriesBlockRecord {
        id
        title
        text
        showCarousel
      }
        ... on ClinicalAreasBlockRecord {
        id
        title
        text
        showLink
      }
         ... on ClientiLoghiBlockRecord {
        id
        title
      }  
        ... on LinkBlockRecord {
        id
        linkLabel
                  linkUrl
                  internalLink {
                    ... on ContentRecord {
                      id
                      slug
                    }
                    ... on ContentsListingRecord {
                      id
                      name
                    }
                    ... on ExpertiseListingRecord {
                      id
                      name
                    }
                    ... on ExpertiseRecord {
                      id
                      slug
                    }
                    ... on IndustryListingRecord {
                      id
                      name
                    }
                    ... on IndustryRecord {
                      id
                      slug
                    }
                    ... on SolutionRecord {
                      id
                      slug
                    }
                    ... on SolutionsListingRecord {
                      id
                      name
                    }
                    ... on StudioPageRecord {
                      id
                      title
                    }
                    ... on AreYouAnAgencyRecord {
                      id
                    }
                    ... on ContactPageRecord {
                      id
                    }  
                  }
          }   
        ... on GridSectionRecord {
          id
          title
          alignment
          gridRows {
            id
            items {
              ... on GridBlockItemRecord {
                id
                image {
                  id
                  responsiveImage(
                    imgixParams: { ar: "16:9", fit: crop, w: "2000", fm: webp }
                  ) {
                    ...ResponsiveImageFragment
                  }
                }
                imageVertical: image {
                  responsiveImage(imgixParams: { auto: format, q: "40", fit: crop }) {
                    ...ResponsiveImageFragment
                  }
                }    
                linkVideo
                linkVideoPreview
                fullWidth
                smallHeight
                sideText
                isVertical
              }
              ... on GridBlockItemTextRecord {
                id
                text
                fullWidth
                fontSizeSmall
                alignment
                link {
                  id
                  linkLabel
                  linkUrl
                  internalLink {
                    ... on ContentRecord {
                      id
                      slug
                    }
                    ... on ContentsListingRecord {
                      id
                      name
                    }
                    ... on ExpertiseListingRecord {
                      id
                      name
                    }
                    ... on ExpertiseRecord {
                      id
                      slug
                    }
                    ... on IndustryListingRecord {
                      id
                      name
                    }
                    ... on IndustryRecord {
                      id
                      slug
                    }
                    ... on SolutionRecord {
                      id
                      slug
                    }
                    ... on SolutionsListingRecord {
                      id
                      name
                    }
                    ... on StudioPageRecord {
                      id
                      title
                    }
                    ... on AreYouAnAgencyRecord {
                      id
                    }
                    ... on ContactPageRecord {
                      id
                    }  
                  }
                }
              }
              ... on TwoColumnsGridTextRecord {
                id
                text
                title
                titleAsSimpleText
              }
              ... on ServicesBlockRecord {
                id
                title
                texts {
                  id
                  title
                  text
                }
              }
            }
          }
        }
      }
    }
      contactBanner(locale: $locale) {
      title
      subtitle
      ctaLabel
      ctaLink
      videoUrl
    }
    contactBanner2(locale: $locale) {
      title
      subtitle
      ctaLabel
      ctaLink
      videoUrl
    }
  }
`
